/**
 * ExpandToggleButton.tsx — 行 / 分组的展开折叠按钮（取自支付商品页分组头的既有样式）
 *
 * ghost 图标按钮 + 右指 chevron，展开时旋转 90°；`aria-expanded` 反映当前状态，title 随状态切换。
 * 支付商品分组头、付费 cohort 语言行等「点一下看下级」的场景共用，避免各页各写一份。
 */

import { Icons } from '~/lib/icons';

interface ExpandToggleButtonProps {
  expanded: boolean;
  onToggle: () => void;
  /** 按钮边长（px），默认 26；表格行内用更小的尺寸 */
  size?: number;
  /** 无障碍名称，缺省按状态取「展开」/「折叠」 */
  label?: string;
}

export function ExpandToggleButton({
  expanded,
  onToggle,
  size = 26,
  label,
}: ExpandToggleButtonProps) {
  return (
    <button
      type="button"
      className="btn btn-ghost btn-icon"
      style={{ width: size, height: size, flexShrink: 0 }}
      aria-expanded={expanded}
      aria-label={label ?? (expanded ? '折叠' : '展开')}
      title={expanded ? '折叠' : '展开'}
      onClick={onToggle}
    >
      <Icons.IconChevRight
        size={Math.round(size * 0.54)}
        style={{
          transform: expanded ? 'rotate(90deg)' : 'none',
          transition: 'transform 0.15s',
          color: 'var(--fg-muted)',
        }}
      />
    </button>
  );
}
